import { render, staticRenderFns } from "./ReminderIndex.vue?vue&type=template&id=fc847f98&"
import script from "./ReminderIndex.vue?vue&type=script&lang=js&"
export * from "./ReminderIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports